module.exports = __webpack_public_path__ + "img/mind_template_item_2_2.6c2f1fe1.png";